SNIPPETS

<template>
    <div 
        :id="'boolean-rating-' + id"
        class="d-flex justify-content-start align-items-center"
    >
        <b-form-radio-group
            :checked="scoreLocal"
            @change="handleScoreSelection"
            :options="finalOptions"
            buttons
            button-variant="outline-input"
            size="sm"
            class="spl-boolean-rating"
            :class="'score-' + scoreString"
        >
        </b-form-radio-group>
        <b-form-checkbox
            v-if="!disableNoScore"
            button
            :checked="noScoreLocal"
            button-variant="outline-input"
            size="sm"
            class="ml-2"
            @change="handleNoScoreSelection"
        >
            N/A
        </b-form-checkbox>
        <b-button
            v-if="isSet"
            variant="bare-secondary"
            size="sm"
            @click="resetValue"
        >
            <b-icon icon="x"></b-icon>
        </b-button>
    </div>
</template>

<script>

export default {
    name: 'BaseRatingBoolean',
    components: {},
    props: {
        score: {
            type: Boolean,
            default: null,
        },
        noScore: {  // set to TRUE if specifically selected N/A, etc.  this takes priority over score value
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: false,
        },
        locked: {  // if true, cannot edit, display only
            type: Boolean,
            default: false,
        },
        disableNoScore: {  // if true, it hides 'N/A' as an option
            type: Boolean,
            default: false,
        },
        trueText: {
            type: String,
            default: 'True',
        },
        falseText: {
            type: String,
            default: 'False',
        }
    },
    data: function() {
        return {

        }
    },
    computed: {
        scoreLocal: function() {
            if (this.noScore) {
                return null;
            }
            return this.score; // can't do normal ternary thing here
        },
        noScoreLocal: function() {
            return this.noScore;
        },
        isSet: function() {
            // boolean for whether it has a value set 
            return (this.score != null) || (this.noScore);
        },
        scoreString: function() { // used to generate class name for button group based on current score, so you can change button colors in CSS, etc.
            return (this.scoreLocal != null) ? this.scoreLocal.toString() : 'empty';
        },
        finalOptions: function() {
            return [
                { text: this.trueText, value: true, },
                { text: this.falseText, value: false, },
            ];
        }
    },
    methods: {
        emitScore: function(scoreValue, noScoreBoolean) {
            // emit multiple things related to score (score, noScore, etc.)
            // WARNING... USE @CHANGE EVENTS ON INPUTS THAT CALL THIS, OTHERWISE IT WILL GET CALLED MULTIPLE TIMES IF YOU USE @INPUT EVENTS
            // @CHANGE EVENTS PREVENT THAT, ONLY CALLING THE EVENT WHICH IS CHANGED BY USER
            this.$emit('score-update', scoreValue);
            this.$emit('no-score-update', noScoreBoolean);
        },
        resetValue: function() {
            // reset all things... doing this will likely make score invalid on parent, but that's whats intended I think
            this.emitScore(null, false);
        },
        handleScoreSelection: function(scoreValue) {
            // if a score is selected, that means N/A should be unselected and score selected
            // no need to set local data... just emit events and let parent circle back with updated values
            console.log('from handleScoreSelection in BaseRatingBoolean - scoreValue is');
            console.log(scoreValue);
            this.emitScore(scoreValue, false);
        },
        handleNoScoreSelection: function() {
            // assume that ANY click on N/A button means N/A should be selected and score should be set to null
            this.emitScore(null, true);
        },
    }
}
</script>

<style>
.spl-boolean-rating.btn-group .btn {
    min-width: 80px;
}
.spl-boolean-rating.btn-group.score-false .btn.active {
    background-color: var(--danger-100) !important;
}
.spl-boolean-rating.btn-group.score-true .btn.active {
    background-color: var(--success-100) !important;
}

</style>